import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiArrowLeft } from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Veuillez entrer votre adresse e-mail.");
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      await api.post('/auth/forgot-password', { email });
      setMessage("Si un compte est associé à cet e-mail, un lien de réinitialisation a été envoyé.");
      toast.success("Demande envoyée ! Veuillez consulter vos e-mails.");
    } catch (error) {
      // Pour des raisons de sécurité, on affiche le même message même en cas d'erreur
      setMessage("Si un compte est associé à cet e-mail, un lien de réinitialisation a été envoyé.");
      console.error("Erreur lors de la demande de réinitialisation:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md bg-white p-8 lg:p-10 rounded-2xl shadow-xl border border-gray-100">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold font-poppins text-gray-900 tracking-tight">Mot de passe oublié ?</h2>
          <p className="text-gray-500 mt-2 text-lg">Entrez votre e-mail pour recevoir un lien de réinitialisation.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2 ml-1">Email</label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-brand-blue transition-colors">
                <FiMail size={20} />
              </div>
              <input
                className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-gray-50 border border-gray-100 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue focus:bg-white transition-all duration-200"
                id="email" type="email" placeholder="votre@email.com"
                value={email} onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          
          {message && <div className="p-4 rounded-xl bg-green-50 border border-green-100 text-green-700 text-sm font-medium text-center">{message}</div>}

          <button 
            disabled={loading} 
            className="w-full flex justify-center items-center py-4 px-4 border border-transparent rounded-xl shadow-lg shadow-brand-blue/20 text-base font-bold text-white bg-brand-blue hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue transition-all duration-200 transform hover:-translate-y-0.5 disabled:opacity-75 disabled:cursor-not-allowed" 
            type="submit"
          >
            {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
          </button>
          
          <p className="text-center text-sm mt-8">
            <Link to="/login" className="font-bold text-brand-blue hover:text-blue-700 transition-colors flex items-center justify-center"><FiArrowLeft className="mr-2" /> Retour à la connexion</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;